import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { ReviewData, ReviewState } from './review.types';

const initialState: ReviewState = {
  grade: '',
  name: '',
  date: '',
  text: '',
  ui: {
    reviewOpened: false,
  },
};

export const reviewSlice = createSlice({
  name: 'review',
  initialState,
  reducers: {
    openReview: (state, { payload }: PayloadAction<ReviewData>) => {
      state.grade = payload.grade;
      state.name = payload.name;
      state.date = payload.date;
      state.text = payload.text;

      state.ui.reviewOpened = true;
    },
    closeReview: (state) => {
      state.ui.reviewOpened = false;
    },
  },
});

export const { openReview, closeReview } = reviewSlice.actions;

export const selectReview = (state: RootState) => state.review;

export const reviewReducer = reviewSlice.reducer;
